import Categories from "./Categories";
import Form from "../Form/Form"
import Icons from "../Icons/Icons";
import {Link, Redirect, useHistory} from "react-router-dom";
import {inject, observer} from "mobx-react";
import {Helmet} from "react-helmet";
import Config from "../../config";
import {useForm} from "react-hook-form";
import {withRouter} from "react-router"
import {useEffect, useState} from "react";

const Header = (props) => {

    let history = useHistory();

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm();

    const [popover, setPopover] = useState(false);

    const clickContrastMode = () => {

        const contrast = localStorage.getItem(`contrast-mode`);

        if (contrast) {
            localStorage.removeItem(`contrast-mode`)
        } else {
            localStorage.setItem(`contrast-mode`, true)
        }

        document.body.classList.toggle(`contrast-mode`);

    }

    const clickSize = () => {
        const root = document.querySelector(`html`);

        const currentSize = localStorage.getItem('font-size');

        root.classList.remove('font-size-a', 'font-size-aa');

        if (!currentSize) {
            localStorage.setItem('font-size', 'a');
            root.classList.add('font-size-a');
            return;
        }

        if (currentSize === 'a') {
            localStorage.setItem('font-size', 'aa');
            root.classList.add('font-size-aa');
            return;
        }

        localStorage.removeItem('font-size');
    };

    useEffect(() => {
        const root = document.querySelector(`html`);
        const size = localStorage.getItem('font-size');

        root.classList.remove('font-size-a', 'font-size-aa');

        if (size) {
            root.classList.add(`font-size-${size}`);
        }
    }, []);

    const onSubmit = (value) => {
        return history.push(`/szukaj?q=${value.q}`)
    }

    return (
        <div className={"container"}>
            <Helmet>
                <title>{props.Settings.item.settings.seo_title}</title>
                <meta name="description" content={props.Settings.item.settings.seo_description}/>
                <meta name="theme-color" content={props.Settings.item.settings.seo_color}/>
                <meta property="og:title" content={props.Settings.item.settings.seo_title}/>
                <meta property="og:description" content={props.Settings.item.settings.seo_description}/>
                <meta property="og:type" content="website"/>
                <meta property="og:image"
                      content={`${Config.urlPublic}/${props.Settings.item.settings.img.controller}/main/${props.Settings.item.settings.img.src}`}/>
                <link rel="canonical" href={Config.url}/>
            </Helmet>
            <div className="py--6 bb">
                <header className="row flex--center flex-md--between">
                    <div className="col-md-2 flex flex--center-xs">
                        <Link to="/" title={props.Settings.item.settings.seo_title}>
                            <img
                                src={`${Config.urlPublic}/${props.Settings.item.settings.img.controller}/main/${props.Settings.item.settings.img.src}`}
                                alt={props.Settings.item.settings.seo_title}
                                loading={"lazy"}
                                className={`logo`}
                            />
                        </Link>
                    </div>
                    <div className="col--auto flex flex--middle">
                        <form onSubmit={handleSubmit(onSubmit)} className="w100 search">
                            <Form.Group>
                                <Form.Input
                                    {...register("q", {
                                        required: "Pole wymagane"
                                    })}
                                    className={`form__control`}
                                    placeholder={`Szukaj`}
                                    type={`search`}
                                />
                                <Form.Button type={"submit"} icon={"search"}/>
                            </Form.Group>
                            {errors.q && <Form.Error>{errors.q.message}</Form.Error>}
                        </form>
                    </div>
                    <div className={`grid--mobile-4 mx--3 flex flex--end flex--middle`}>
                        {popover && <div className="popover-login is-active">
                            <span className="popover-login__title">Wybierz wersję, do której chcesz się zalogować</span>
                            <a href="https://ebanknet.bs.olawa.pl/nowa-bankowosc-internetowa/"
                               className="popover-login__button popover-login__button-primary">
                                <span>NOWA BANKOWOŚĆ INTERNETOWA</span>
                                <span className="popover-login__button__subtitle">Poznaj odświeżony interfejs, nowe funkcje i łatwiejszą obsługę</span>
                            </a>
                            <a href="https://ebanknet.bs.olawa.pl/"
                               className="popover-login__button popover-login__button-secondary">
                                <span>Dotychczasowa Bankowość Internetowa</span>
                                <span className="popover-login__button__subtitle">Korzystaj ze znanej i sprawdzonej wersji systemu</span>
                            </a>
                            <span className="popover-login__subtitle">Obie wersje działają równolegle, masz swobodę wyboru!</span>
                        </div>}
                        <button title={"Logowanie do bankowości internetowej"}
                                type="button"
                                onClick={() => setPopover(!popover)}
                                className={`btn btn--header btn--header-is-primary header--icon mr--2 popover-anchor`}>
                            <Icons name={`user`} className={`mr--2 text--l`}/> Zaloguj się
                        </button>
                        <Link to={"/kontakt"} title={"Kontakt"}
                              className={`btn btn--header btn--header-is-icon mr--2 header--short`}>
                            <Icons name={`phone`} className={`mr--2 text--l`}/>
                        </Link>
                        <button onClick={clickSize} aria-label="Powiększ litery"
                                className={`btn btn--header btn--header-is-icon mr--2 header--short`}>
                            A++
                        </button>
                        <button onClick={() => clickContrastMode()} aria-label="Włącz wysoki kontrast"
                                className={`btn btn--header btn--header-is-icon mr--2 header--short`}>
                            <Icons name={`contrast`} className={`text--l`}/>
                        </button>
                        <a href={"https://www.facebook.com/bs.olawa/"} rel="noreferrer" target="_blank"
                           title={"Przejdź do Facebook"}
                           className={`btn btn--header btn--header-is-icon header--short`}>
                            <Icons name={`facebook`} className={`text--l`}/>
                        </a>
                    </div>
                </header>
            </div>
            <Categories/>
        </div>
    )

}

export default inject('Settings')(withRouter(observer(Header)))

